import React from 'react'
import Tright from '../../components/others/textImage/tright'
import Tleft from '../../components/others/textImage/tleft'
import StoryImage from '../../images/about/SCom.png'
import CommunityImage from '../../images/about/Target.jpg'
import CallToAction from '../../components/others/callToActionText/ctat1'
import DocumentMeta from 'react-document-meta';
const about = () => {
  const meta = {
    /*title: 'New Arrivals | Latest & trendy Products on KAAY',
    description: "Discover the latest products from various Brands, local vendors & artists in our New Arrivals section. From clothing, accessories, handmade crafts to unique gifts, there's something for everyone in our constantly updated selection. Our social commerce platform makes it easy for sellers to showcase their products & reach a wider audience.",
    */
    canonical: window.location.href
    /*canonical: 'http://example.com/path/to/page',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }
  const StoryMessage = [
    "KAAY is founded by Mr Muhammad Umer Ikram with the vision to empower SMEs of Pakistan, specifically in fashion and art industry and to give them international exposure.",
    "KAAY is Pakistan’s first fashion social commerce [s-commerce] platform that will act as a two-sided marketplace. A unique blend of Instagram and eBay with every seller getting back end features as Shopify without any SignUp cost.",
    "Other than the fashion industry KAAY will be boarding local artists to publish and sell their artwork and craft products on this platform."
  ];
  const CommunityMessage = [
    "KAAY’s vision is to open a platform where all the on board business can showcase and sell their product in international markets. With this vision the business can get international exposure without spending any money.",
    "Being a borderless online platform, international exposure will increase exports of our country and KAAY intend to contribute in Pakistan’s economy."
  ];
  const CTATMessage = [
    "KAAY is currently powered by 22 employees working from Pakistan, CEO, Directors, Design team and CSR team works from the headquarter in Lahore. Then KAAY have around +100 campus ambassadors working from their respective universities and onboarding new talent all over Pakistan."
  ]
  const JOBSMessage = [
    "Don’t see your dream job? Think outside of the box. Show us something we’ve never seen before. Excite us. Challenge us. Our employees are driven by passion, and we want to work with people who love KAAY just as much as we do. Email your marketing pitches, growth hacks, UX re-designs, and genius ideas that only you can think of to jobs@kaay.pk with your resume. We’re always open."
  ]
  return (
    <div className='about_wrapper'>
    <DocumentMeta {...meta} />
      <h2>Join to buy, sell, discover and explore the most inspiring and unique fashion & Art in the world.</h2>
      <Tleft Title="Story" Message={StoryMessage} Image = {StoryImage} Class = 'light'/>
      <CallToAction Title="TEAM" Message={CTATMessage} Url="#" UrlTitle="" Class="dark"/>
      <Tright Title="Vision" Message={CommunityMessage} Image = {CommunityImage} Class = 'light'/>
      <div className='contact_details_wrapper'>
        <div className='contact_details_container'>
          <div className='contact_details_title'>
            <h3>KAAY Segmentations</h3>
          </div>
          <div className='contact_details_item'>
            <h4>B2C</h4>
            <p>Businesses can setup their shops on KAAY to sell their products to customers.</p>
          </div>
          <div className='contact_details_item'>
            <h4>C2C</h4>
            <p>Customers can post their Preloved / new products to sell it on KAAY.</p>
          </div>
          <div className='contact_details_item'>
            <h4>Wholesale</h4>
            <p>Businesses can list their products in the wholesale category for other businesses to buy from them at wholesale price.</p>
          </div>
        </div>
      </div>
      <CallToAction Title="Careers" Message={JOBSMessage} Url="#" UrlTitle="" Class="dark"/>
      <div className='contact_details_wrapper'>
        <div className='contact_details_container'>
          <div className='contact_details_title'>
            <h3>Get in touch</h3>
          </div>
          <div className='contact_details_item'>
            <h4>Visit</h4>
            <p>148 Ejaz Park, opp 37-P, Model towm link road, Lahore</p>
          </div>
          <div className='contact_details_item'>
            <h4>Helpline</h4>
            <p> +92 311 1777 566 <br></br>042 3522 2546</p>
          </div>
          <div className='contact_details_item'>
            <h4>Email</h4>
            <p>Help@kaay.pk</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default about
